<script lang="ts">
	import { createEventDispatcher, onMount } from 'svelte';
	import { sineOut } from 'svelte/easing';
	import { fade, fly } from 'svelte/transition';
	import Close from '../icons/Close.svelte';
	import Chat from '$lib/assets/icons/chat.svelte';
	import { log10 } from 'chart.js/helpers';

	export let questions: any;
	export let is_dark: any;
	export let is_subscription: boolean;
	export let cookiesQuestions: any;

	let activeQuestion: any;
	let selectedId: number | null;

	$: is_subscription;
	$: questions;
	$: selectedId;
	$: activeQuestion = undefined;
	let isClosed = false;
	let lastAnswer = false;

	$: questions = questions.filter((question: any) => question.is_active == true);

	// Убираем вопросы которые были выбраны ранее
	if (cookiesQuestions) {
		cookiesQuestions = JSON.parse(cookiesQuestions);
		questions = questions.filter((question: any) => {
			return cookiesQuestions?.indexOf(question.id) == -1;
		});
	}

	questions.sort((a: any, b: any) => a.id - b.id);

	const dispatch = createEventDispatcher();
	function handleAnswer(answer_id: any, question_id: any, id: number) {
		selectedId = id;

		dispatch('answer', {
			answer_id,
			question_id
		});

		setTimeout(() => {
			if (questions.length > 0) {
				activeQuestion = questions[0];
			} else {

				// Показать спасибо
				lastAnswer = true;

				// Скрыть спасибо
				setTimeout(() => {
					lastAnswer = false;
				}, 1500);
			}
			selectedId = null;
		}, 400);
	}

	onMount(() => {
		setInterval(() => {
			if (questions.length > 0) {
				activeQuestion = questions[0];
			}
		}, 1000);
	});

	const handleClose = () => {
		isClosed = !isClosed;
	};
</script>

{#if questions.length > 0 && !isClosed}
	{#if activeQuestion?.id == questions[0].id}
		<div
			in:fly={{ delay: 0, duration: 300, x: 0, y: 500, opacity: 0.1, easing: sineOut }}
			class="absolute z-20 {is_subscription
				? 'bottom-2'
				: 'bottom-2'} left-2 right-2 md:max-w-96 text-center shadow-xl flex flex-col {is_dark
				? 'bg-base-950'
				: 'bg-white'}  rounded-md px-4 py-4"
		>
			<div class="pb-4 font-body text-center">
				{questions[0].text}
			</div>
			<div class="flex gap-2 justify-center pb-1">
				{#each questions[0].type.data as item, id}
					<button
						on:click={() => handleAnswer(item.id, questions[0].id, id)}
						class="
						 hover:bg-secondary-300
						 {selectedId == id ? 'bg-secondary-300 ' : ''}
						 {is_dark
							? 'bg-gradient-to-b from-base-900 to-base-900/50 '
							: ' bg-secondary-100 '} 
						 px-4 py-2 text-sm rounded-xl"
					>
						{item.title}
					</button>
				{/each}
			</div>
			<div
				in:fade={{ delay: 400, duration: 300, easing: sineOut }}
				class="self-end absolute -top-6 right-0"
			>
				<button on:click={handleClose} class="w-4">
					<Close />
				</button>
			</div>
		</div>
	{/if}
{:else if questions.length > 0 && isClosed}
	<button on:click={handleClose} class="w-4">
		<div
			in:fly={{ delay: 0, duration: 300, x: 0, y: 500, opacity: 0.1, easing: sineOut }}
			class="absolute z-20 {is_subscription
				? 'bottom-2'
				: 'bottom-2'} left-2 text-center shadow-xl flex {is_dark
				? 'bg-base-950'
				: 'bg-white'}  rounded-full px-4 py-4"
		>
			<div class="w-5">
				<Chat />
			</div>
		</div>
	</button>
{:else if lastAnswer}
	<button on:click={handleClose} class="w-10">
		<div
			in:fly={{ delay: 0, duration: 300, x: 0, y: 500, opacity: 0.1, easing: sineOut }}
			out:fly={{ delay: 0, duration: 300, x: 0, y: 500, opacity: 0.1, easing: sineOut }}
			class="absolute z-20 {is_subscription
				? 'bottom-2'
				: 'bottom-2'} left-2 right-2 justify-center text-center shadow-xl flex {is_dark
				? 'bg-base-950'
				: 'bg-white'}  rounded-xl px-4 py-4"
		>
			<div class="w-20">Спасибо!</div>
		</div>
	</button>
{/if}
